<template>
  <div>
    <add-edit-promo-dialog
      ref="addEditPromoDialog"
      @onInsert="FetchItems()"
      @onUpdate="FetchItems()"
    />

    <delete-dialog
      ref="deleteForm"
      @confirm-delete="DeleteItem"
    />
    <v-card>
      <!-- search -->
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <div class="d-flex align-center pb-5">
          <h1>Promos</h1>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex align-center pb-5">
          <v-text-field
            v-model="searchQuery"
            single-line
            dense
            outlined
            hide-details
            placeholder="Buscar"
            class="me-3"
          ></v-text-field>

          <!-- create new -->
          <v-btn
            color="primary"
            class="me-3"
            @click="addEditPromoDialog.ShowDialog()"
          >
            <v-icon
              size="18"
              class="me-1"
            >
              {{ icons.mdiPlus }}
            </v-icon>
            <span>Nuevo</span>
          </v-btn>
        </div>
      </v-card-text>

      <!-- table -->
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        class="text-no-wrap"
      >
        <!-- active -->
        <template #[`item.active`]="{ item }">
          <statuses :status="item.active" />
        </template>

        <!-- actions -->
        <template #[`item.actions`]="{ item }">
          <div class="d-flex align-center justify-center">
            <!-- delete -->
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="ShowDeleteDialog(item)"
                >
                  <v-icon size="18">
                    {{ icons.mdiDeleteOutline }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Eliminar</span>
            </v-tooltip>

            <!-- Edit  -->
            <table-action-button
              :icon="icons.mdiPencilOutline"
              text="Editar"
              @OnClick="addEditPromoDialog.ShowDialog(item)"
            />
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mdiPlus, mdiDeleteOutline, mdiPencilOutline } from '@mdi/js'

// composition function
import { ref, watch } from '@vue/composition-api'
import store from '@/store'
import deleteDialog from '@/components/dialogs/DeleteDialog.vue'
import AddEditPromoDialog from './AddEditPromoDialog.vue'
import TableActionButton from '@/components/controls/TableActionButton.vue'
import Statuses from '@/components/chips/Statuses.vue'

export default {
  components: {
    deleteDialog,
    AddEditPromoDialog,
    TableActionButton,
    Statuses,
  },
  setup() {
    const deleteForm = ref('delete-dialog')
    const editForm = ref('edit-dialog')
    const ShowDeleteDialog = item => {
      deleteForm.value.ShowDeleteDialog(item.promoKey, item.name)
    }
    const ShowEditDialog = item => {
      editForm.value.ShowEditDialog(item.promoKey)
    }

    const items = ref([])

    // Table Handlers
    const headers = [
      { text: '#ID', align: 'start', value: 'promoId' },
      { text: 'Nombre', value: 'name' },
      { text: 'Is Percentage', value: 'isPercentage' },
      { text: 'Valor', value: 'value' },
      { text: 'Id De Usuario', value: 'userId' },
      { text: 'Creado En', value: 'createdOn' },
      { text: '', value: 'active', sortable: false },
      {
        text: 'Acciones', value: 'actions', align: 'center', sortable: false,
      },
    ]

    const active = {
      1: 'Activo',
      0: 'Inactivo',
    }

    const activeColor = {
      Activo: 'success',
      Inactivo: 'default',
    }

    const searchQuery = ref('')
    const options = ref({
      sortBy: [],
      sortDesc: [],
    })
    const totalItems = ref(0)
    const loading = ref(false)
    const isAddEditSidebarActive = ref(false)

    const FetchItems = () => {
      loading.value = true
      store
        .dispatch('promos/apiCall', {
          mode: 'select',
          request: {
            q: searchQuery.value,
            srt: options.value.sortBy,
            desc: options.value.sortDesc,
            pg: options.value.page - 1,
            ippg: options.value.itemsPerPage,
            all: process.env.VUE_APP_API_ALL,
          },
        })
        .then(response => {
          if (response.success) {
            items.value = response.data.items
            totalItems.value = response.data.total
          }
        })
        .finally(() => {
          loading.value = false
        })
    }

    watch([searchQuery], () => {
      options.value.page = 1
      FetchItems()
    })

    watch([options], () => {
      FetchItems()
    })

    const DeleteItem = key => {
      store
        .dispatch('promos/apiCall', {
          mode: 'Delete',
          request: {
            key,
          },
        })
        .then(response => {
          if (response.success) {
            FetchItems()
          }
        })
    }

    /** AddEdit Dialog */
    const addEditPromoDialog = ref()

    return {
      active,
      activeColor,
      headers,
      searchQuery,
      options,
      totalItems,
      items,
      loading,
      isAddEditSidebarActive,
      deleteForm,
      editForm,
      DeleteItem,
      FetchItems,
      ShowDeleteDialog,
      ShowEditDialog,

      // AddEditDialog
      addEditPromoDialog,

      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiPencilOutline,
      },
    }
  },
}
</script>
